import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Vat} from '../objects/vat';
import {ConfigUtil} from '@shared/services/config.util';

@Injectable({
  providedIn: 'root'
})
export class VatApi {
  private readonly httpClient = inject(HttpClient);

  private readonly endpoint: string;

  constructor() {
    this.endpoint = `${ConfigUtil.get('api')['backend']}/vat`;
  }

  public findAll(): Observable<Vat[]> {

    return this.httpClient.get<Vat[]>(`${this.endpoint}`);
  }

  public findById(id: number): Observable<Vat> {
    return this.httpClient.get<Vat>(`${this.endpoint}/${id}`).pipe(map(value => {
      return Object.assign(new Vat(), value);
    }));
  }

  public findByAdministration(administrationUuid: string): Observable<Vat[]> {
    return this.httpClient.get<Vat[]>(`${this.endpoint}?administration=${administrationUuid}`);
  }

  public save(administrationUuid: string, vat: Vat): Observable<Vat> {
    return this.httpClient.post<Vat>(`${this.endpoint}?administration=${administrationUuid}`, vat).pipe(map(value => {
      return Object.assign(new Vat(), value);
    }));
  }

  public update(vat: Vat): Observable<boolean> {
    return this.httpClient.put<boolean>(`${this.endpoint}/${vat.id}`, vat);
  }
}
